/* eslint-disable */
import { Box, Divider, Grid, Typography } from '@material-ui/core';
import React from 'react';
import PhoneNumberDetection from '../PhoneNumberDetection';
import { userActions } from 'redux/actions';
import { sendMsgToExt } from 'util/messagePassing';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import WebExtensionSettings from '@icimscorp/mui-acs/build/components/WebExtensionSettings';
import { LanguageSelection } from '@icimscorp/mui-acs';
import BlacklistedDomain from '../BlacklistedDomain';
// eslint-disable-next-line id-match
import { outbound } from 'extActions';
import PropTypes from 'prop-types';

const maxAllowedBlacklistedDomains = 100;

const Preferences = ({ handleWebExtensionSettingsClose }) => {
	const dispatch = useDispatch();
	const [t, i18n] = useTranslation('acs');
	const { preferences, currentExtensionWebPageOrigin, timeZone } = useSelector(
		(state) => state.user
	);
	const [langKey, setLangKey] = React.useState(i18n.language);
	const [isOnBlacklistedDomain, setIsOnBlacklistedDomain] = React.useState(false);

	const { isSwitchOn, blacklistedDomains } = preferences;

	React.useEffect(
		() => {
			setIsOnBlacklistedDomain(blacklistedDomains.includes(currentExtensionWebPageOrigin));
		},
		[currentExtensionWebPageOrigin, blacklistedDomains]
	);

	/**
	 * Steps after user excludes current domain:
	 * 1. Toggle highlight switch button
	 * 2. Disable highlight switch button
	 * 3. Post "exclude domain" message to extension
	 *
	 * The extension will then:
	 * 1. Stop phone number highlighting, and
	 * 2. Capture the current origin and return a respond back.
	 * See src/Root/messageHandler.js `DOMAIN_TO_EXCLUDE` action for more info.
	 */
	const handleExcludeDomain = () => {
		/**
		 * Prevent user from blacklisting more than 100 domains:
		 * - To keep a cleaner UI
		 * - Limited storage available in browser-extension's storage: https://developer.chrome.com/extensions/storage#type-StorageArea
		 */
		if (blacklistedDomains.length >= maxAllowedBlacklistedDomains) {
			return;
		}
		if (isSwitchOn) {
			dispatch(userActions.toggleSwitch());
		}
		/**
		 * Command the extension to stop detecting phone numbers
		 */
		sendMsgToExt({ action: outbound.EXCLUDE_DOMAIN });
	};

	const handleLanguageChange = (lang) => {
		setLangKey(lang);
		i18n.changeLanguage(lang);
	};

	return (
		<div>
			<WebExtensionSettings
				data-testid="preferences"
				handleExcludeButtonOnClick={!isOnBlacklistedDomain ? handleExcludeDomain : null}
				excludeButtonDisabled={isOnBlacklistedDomain || !isSwitchOn}
				handleWebExtensionSettingsClose={handleWebExtensionSettingsClose}
			>
				<Grid
					container
					direction="row"
					style={{
						maxHeight: 'calc(55vh)',
						overflowY: 'auto',
						overflowX: 'hidden',
						paddingLeft: 0,
						paddingRight: 0,
						marginBottom: 0,
						backgroundColor: '#ffffff'
					}}
				>
					<Grid item xs={12} style={{ fontSize: '14px', left: 0 }}>
						{blacklistedDomains.map((urlOrigin) => (
							<BlacklistedDomain key={urlOrigin} urlOrigin={urlOrigin} />
						))}
					</Grid>
				</Grid>
			</WebExtensionSettings>
			<Divider />
			<Box mr={4.5} mt={1.5} ml={1.5}>
				<Typography variant="h5" style={{ marginLeft: 12 }}>
					{t('select_language', 'Select a Language')}
				</Typography>
				<LanguageSelection
					preferredLanguage={langKey}
					handleLanguageChange={(e) => handleLanguageChange(e.target.value)}
				/>
			</Box>
			<PhoneNumberDetection data-testid="phoneRegions" />
		</div>
	);
};

Preferences.propTypes = {
	handleWebExtensionSettingsClose: PropTypes.func
};

export default Preferences;
